import axios from 'axios'

export const UrlApi = {
    async Redirect(data){
        const response = await axios.get(`/api/url/redirect/${data}`)
        return response
    }
}